import cn from 'bem-cn';

import { Stack } from '../UI';
import { formatRussianDate } from '../../utils/date/date';
import { getImageUrl, ImageSize } from '../../utils/images';
import { getAvatarSrc } from '../../contexts/UserContext/UserContext.helpers';
import { AvatarSize } from '../../contexts/UserContext/UserContext.types';

import { PromptInfoStatistics } from './PromptInfoStatistics';
import { PromptInfoHeader } from './PromptInfoHeader';
import { PromptInfoBody } from './PromptInfoBody';
import { PromptInfoAuthor } from './PromptInfoAuthor';

import { PromptInfoProps } from './PromptInfo.types';
import './PromptInfo.scss';

const b = cn('prompt-info');

export const PromptInfo = (props: PromptInfoProps) => {
    const { prompt, onLikeClick, onShareClick, isMediaPrompt } = props;
    const {
        likes,
        isLiked,
        visits,
        imageData,
        title,
        description,
        categories,
        promptForExample,
        example,
        exampleImage,
        videoData,
        author,
        createdAt,
    } = prompt;
    const formattedDate = formatRussianDate(createdAt);

    return (
        <Stack className={b({ mediaprompt: isMediaPrompt })}>
            <PromptInfoHeader
                image={getImageUrl(imageData.url, ImageSize.Small)}
                title={title}
                description={description}
                categories={categories}
            />
            <PromptInfoStatistics
                likes={likes}
                isLiked={isLiked}
                views={visits}
                onLikeClick={onLikeClick}
                onShareClick={onShareClick}
            />
            <PromptInfoBody
                data={{
                    promptImage: getImageUrl(imageData.url, ImageSize.Big),
                    promptForExample,
                    example,
                    exampleImage,
                    exampleVideo: videoData.url,
                    isMediaPrompt,
                }}
            />
            {
                <PromptInfoAuthor
                    author={{ ...author, image: getAvatarSrc(author.image, AvatarSize.Medium) }}
                    subtitle="Автор"
                />
            }
            <p className={b('created-at')}>Опубликовано: {formattedDate}</p>
        </Stack>
    );
};
